var exports = {
  "kL": "xe533113f--d19fc6--container",
  "Ew": "xe533113f--d19fc6--notification",
  "A4": "xe533113f--d19fc6--control",
};

module.exports = exports;
